import { render, staticRenderFns } from "./MultipleAccountIcon.vue?vue&type=template&id=86b4ac5a"
import script from "./MultipleAccountIcon.vue?vue&type=script&lang=js"
export * from "./MultipleAccountIcon.vue?vue&type=script&lang=js"
import style0 from "./MultipleAccountIcon.vue?vue&type=style&index=0&id=86b4ac5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports